// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1l1dD","loaderOuter":"PageOverlayLoader_loaderOuter__3zfm7"};